import { gsap } from 'gsap'
import { Flip } from 'gsap/Flip'

import { motion } from '../tokens'

/*
 * Ponto único de registro do GSAP. Módulos ES avaliam uma vez, então o registro e os
 * padrões (duração base, easing de entrada) acontecem uma única vez por aplicação.
 * Importe `gsap` e `Flip` daqui (ou de '@gestao/ui'), nunca direto do pacote.
 */
gsap.registerPlugin(Flip)
gsap.defaults({ duration: motion.duration.base / 1000, ease: motion.ease.entrance })

export { Flip, gsap }
